import { render, staticRenderFns } from "./DispatchPartners.vue?vue&type=template&id=1712a7b3&scoped=true"
import script from "./DispatchPartners.vue?vue&type=script&lang=js"
export * from "./DispatchPartners.vue?vue&type=script&lang=js"
import style0 from "./DispatchPartners.vue?vue&type=style&index=0&id=1712a7b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1712a7b3",
  null
  
)

export default component.exports